export const CHECKOUT_URL =
  "https://pay.hotmart.com/L107553141O?checkoutMode=10&bid=1789045724875";

export const TRUST_ITEMS = [
  "Pago 100% seguro vía Hotmart",
  "Acceso de por vida",
  "Garantía de 7 días",
];
